import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-bg-card text-txt-primary py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 border-b border-line" data-id="element-307">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-308">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-309">
          <span className="animate-pulse hidden md:inline" data-id="element-310">⏰</span>
          <span className="hidden md:inline" data-id="element-311">
            OFERTA DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-312">LANZAMIENTO —</span>
          <span className="font-bold bg-brandYellow/10 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base text-brandYellow" data-id="element-313">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandGold font-bold text-[10px] md:text-base" data-id="element-314">
          Después vuelve a su precio original. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-315">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-316">
        <FadeIn data-id="element-317">
          <div className="space-y-2 md:space-y-4" data-id="element-318">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandYellow font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandYellow/30" data-id="element-319">
              <span className="text-sm md:text-base" data-id="element-320">🛒</span>
              <span className="text-[8.5px]" data-id="element-321">
                SISTEMA N°1 PARA VENDEDORES DE ARGENTINA
              </span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[32px] md:text-[72px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-322">
              POTENCIA TU NEGOCIO
              <br data-id="element-323" />
              VENDIENDO DE FORMA{' '}
              <span className="text-brandYellow" data-id="element-324">DIGITAL.</span>
              <br data-id="element-325" />
              <span data-id="element-326">DESDE HOY.</span>
            </h1>
            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-327">
              6 Tomos · 6 Bonos · Sistema Completo · Todo lo que necesitás para
              vender, rankear y ganar en MeLi Argentina
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-328">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-329">
            <div className="absolute inset-0 bg-brandYellow/10 blur-[80px] rounded-full" data-id="element-330"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[60px] rounded-full" data-id="element-331"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4p7HE5ixBSKoBh4AAubvnx/MOckup_sin_fondo.png" alt="MEGAPACK Comercio Productivo 2026 — Sistema completo para vender en Mercado Libre" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-332" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-333">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-334">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-335">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-336">
                <span className="text-[10px] md:text-xs" data-id="element-337">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-338">
                <span className="text-[10px] md:text-xs" data-id="element-339">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-340">
                <span className="text-[10px] md:text-xs" data-id="element-341">📚</span> 6 Tomos
                completos
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-342">
                <span className="text-[10px] md:text-xs" data-id="element-343">🛒</span> Sistema MeLi
                2026
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-344">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-345">
                🛒 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-346">
                <span className="flex items-center gap-1" data-id="element-347">
                  <ShieldCheck size={11} className="text-success" data-id="element-348" /> Garantía 15
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-349">
                  <Lock size={11} className="text-txt-muted" data-id="element-350" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-351">
                  <CreditCard size={11} className="text-brandGold" data-id="element-352" /> Mercado
                  Pago
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-353">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-354">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-355">
          <FadeIn delay={0.1} data-id="element-356">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandGold mb-0.5" data-id="element-357">
              +500
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-358">
              comerciantes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-359">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandGold mb-0.5" data-id="element-360">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-361">Tomos listos</div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-362">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandGold mb-0.5" data-id="element-363">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-364">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-365">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandGold mb-0.5" data-id="element-366">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-367">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-368" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Por primera vez en años entré a MeLi con todo listo. En la primera semana recuperé lo que pagué y más.',
    author: 'Marcos R.',
    role: 'Comerciante · Bs. As.',
    bg: 'bg-[#FF6B00]'
  }, {
    initials: 'CP',
    text: 'Tenía miedo de lo impositivo. El Tomo 2 me ordenó todo. Ahora vendo tranquila y sé exactamente lo que gano.',
    author: 'Carolina P.',
    role: 'Revendedora · Córdoba',
    bg: 'bg-[#3B82F6]'
  }, {
    initials: 'DG',
    text: 'En 10 minutos armé mi primera publicación profesional. Mis competidores no entienden cómo aparezo primero.',
    author: 'Diego G.',
    role: 'Dueño de negocio · Rosario',
    bg: 'bg-[#10B981]'
  }];
  return <Section className="bg-bg-base" data-id="element-369">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-370">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-371">
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-372">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-373">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-374">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-375">
                  <div className="flex text-gold mb-0.5" data-id="element-376">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-377" />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-378">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-379">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-380">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Tu negocio físico funciona, pero sentís que estás perdiendo ventas por no estar en Mercado Libre', 'Tenés mercadería parada en el local mientras miles de personas la buscan online todos los días', 'Pasás horas armando publicaciones que no generan ventas y no entendés qué está fallando', 'Querés vender por internet, pero no sabés por dónde empezar', 'Cada mes los costos aumentan, pero las ventas no crecen al mismo ritmo', 'Ves que otros venden todos los días en Mercado Libre y no entendés qué están haciendo diferente', 'Sabés que el comercio está cambiando, pero no querés quedarte atrás mientras otros se llevan tus clientes'];
  return <Section className="bg-bg-alt" data-id="element-381">
      <div className="max-w-[720px] mx-auto" data-id="element-382">
        <FadeIn data-id="element-383">
          <h2 className="font-display font-extrabold uppercase md:text-[44px] text-center mb-8 text-txt-primary text-[28px]" data-id="element-384">
            Si tenés un <span className="text-brandGold" data-id="element-385">negocio,</span>
            <br data-id="element-386" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-387">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-388">
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-389" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-390">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #F5A623 50%, transparent 100%)',
          boxShadow: '0 0 8px rgba(245,166,35,0.4), 0 0 16px rgba(245,166,35,0.2)'
        }} data-id="element-391"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[52px] text-center text-txt-primary mb-8 relative text-[30px]" data-id="element-392">
            ¿HASTA CUÁNDO VAS A SEGUIR VIENDO EL{' '}
            <span className="text-brandYellow inline-block" style={{
            textShadow: '0 0 20px rgba(255,230,0,0.4), 0 0 40px rgba(255,230,0,0.2)'
          }} data-id="element-393">
              CRECIMIENTO DIGITAL
            </span>{' '}
            DESDE AFUERA?
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-394">
            <p data-id="element-395">
              Abriste tu negocio porque querías construir algo propio y hacerlo
              crecer.
            </p>
            <p data-id="element-396">
              Le dedicaste tiempo, esfuerzo y dinero para llegar hasta acá. Pero
              sabés que vender solo desde el local hoy ya no alcanza.
            </p>
            <p data-id="element-397">
              Querés aprovechar Mercado Libre para llegar a más clientes, pero
              no sabés por dónde empezar ni cómo hacerlo correctamente.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandYellow rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_20px_rgba(255,230,0,0.1)]" data-id="element-398">
            <p className="font-display font-extrabold text-[20px] md:text-[28px] leading-[1.2] text-center text-txt-primary" data-id="element-399">
              ¿Y si este fuera el{' '}
              <span className="text-brandYellow" data-id="element-400">primer paso</span>
              <br data-id="element-401" />
              para{' '}
              <span className="text-brandYellow" data-id="element-402">multiplicar tus ventas</span>?
            </p>
          </div>

          {/* Divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #F5A623 50%, transparent 100%)',
          boxShadow: '0 0 8px rgba(245,166,35,0.4), 0 0 16px rgba(245,166,35,0.2)'
        }} data-id="element-403"></div>
        </FadeIn>
      </div>
    </Section>;
};